import { createFeatureFlagApi } from '@trackly/shared';
import { createAuthenticatedBaseQuery } from '../../utils/createAuthenticatedBaseQuery';
import { getTicketsApiBaseUrl } from '../../utils/runtimeConfig';

const apiBaseUrl = getTicketsApiBaseUrl();

/**
 * Single feature flag API instance for the web client — the endpoint lives in @trackly/shared
 * (createFeatureFlagApi); only the authenticated baseQuery is web-specific.
 */
export const featureFlagApi = createFeatureFlagApi(
  createAuthenticatedBaseQuery(apiBaseUrl, 'Feature Flag API')
);

export const { useGetFeatureFlagsQuery } = featureFlagApi;
